import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';

const InvalidLinkState = () => {
  return (
    <div className="text-center">
      <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-5">
        <Icon name="LinkOff" size={28} className="text-red-500" />
      </div>

      <h2 className="text-xl font-heading font-semibold text-text-primary mb-3">Link Expired or Invalid</h2>

      <p className="text-sm text-text-secondary leading-relaxed mb-6">
        This password reset link has expired or is no longer valid. Reset links are only valid for <strong>1 hour</strong> after they are sent.
      </p>

      <div className="space-y-3">
        <Link
          to="/forgot-password-request"
          className="w-full bg-primary text-white py-3 px-4 rounded-lg font-medium hover:bg-primary-700 transition-smooth flex items-center justify-center gap-2"
        >
          <Icon name="RefreshCw" size={18} />
          Request New Reset Link
        </Link>

        <Link
          to="/login"
          className="w-full border border-border text-text-primary py-3 px-4 rounded-lg font-medium hover:bg-background transition-smooth flex items-center justify-center gap-2"
        >
          <Icon name="ArrowLeft" size={18} />
          Back to Sign In
        </Link>
      </div>
    </div>
  );
};

export default InvalidLinkState;
